import { ITagPlateSample } from '@models/upload';

export enum enumProjectTypes {
  CDx,
  COVID,
}

export interface IMrdStatus {
  key: string;
  value: string;
}

export type TestTypes = 'ID' | 'MRD' | 'CALIB' | null;

export enum MrdStatus {
  NA = 'NA',
  MrdEnabled = 'MrdEnabled',
  NoClonesFound = 'NoClonesFound',
  IdPending = 'IdPending',
}

export enum MrdStatusKeys {
  SubjectMrdStatus = 'SubjectMrdStatus',
}

export const findMRDStatus = (
  keyValue: MrdStatusKeys,
  statuses: IMrdStatus[]
) => {
  // loop through statuses looking for keyValue
  const mrdStatus = statuses.filter(({ key }) => key === keyValue);
  if (mrdStatus.length > 0) {
    return mrdStatus[0].value;
  }

  // no property data was returned with expected keys, return empty string.
  return '';
};

export const generateMRDStatusText = (statuses: IMrdStatus[]) => {
  let mrdStatusText: string = '';
  if (statuses.length > 0) {
    // remove this in the future when we expand to multiple products
    const hardcodeKey = MrdStatusKeys.SubjectMrdStatus;
    // find the status to use based off product CDx, COVID, etc...
    mrdStatusText = findMRDStatus(hardcodeKey, statuses);
  }

  return mrdStatusText;
};

export interface ISubjectsStateProps {
  subjects: ISubjectStateProps[];
}
export interface ISubjectsDispatchProps {
  newExperiment: boolean;
  select: (subject: ISubjectStateProps) => void;
}

export interface ISubjectDispatchProps {
  select: () => void;
  newExperiment: boolean;
}

export interface ISubjectStateProps
  extends Pick<
    ITagPlateSample,
    | 'externalSubjectId'
    | 'displayColor'
    | 'name'
    | 'testType'
    | 'controlType'
    | 'properties'
  > {
  wells: string[];
  selected: boolean;
}
